module.exports = __webpack_public_path__ + "img/contact2.202f7ae1.png";